import { useState } from "react";
import { Eye, EyeSlash } from "@phosphor-icons/react";
import { Input } from "./ui/input";

export const PasswordInput = ({ className = "", ...props }) => {
  const [show, setShow] = useState(false);
  const testId = props["data-testid"] || "password-input";
  return (
    <div className="relative">
      <Input {...props} type={show ? "text" : "password"} className={`${className} pr-11`} />
      <button
        type="button"
        tabIndex={-1}
        data-testid={`${testId}-toggle`}
        aria-label={show ? "Nascondi password" : "Mostra password"}
        onClick={() => setShow((s) => !s)}
        className="absolute right-3 top-1/2 -translate-y-1/2 text-white/40 hover:text-white/80 transition-colors"
      >
        {show ? <EyeSlash size={18} weight="duotone" /> : <Eye size={18} weight="duotone" />}
      </button>
    </div>
  );
};
